module.exports = __webpack_public_path__ + "media/images/flags/TJ-cc182b947c3645a73f9ab2f645cb974c.svg";